import { useCallback, useState } from "react"

export interface ModalProps {
  isOpen: boolean
  onClose: () => void
}

export const useModal = <TData>() => {
  const [isOpen, setIsOpen] = useState(false)
  const [data, setData] = useState<TData | null>(null)
  const closeModal = useCallback(() => setIsOpen(false), [])
  const openModal = useCallback((inpData?: TData) => {
    if (inpData) {
      setData(inpData)
    }
    setIsOpen(true)
  }, [])
  return {
    isOpen,
    closeModal,
    openModal,
    data,
  }
}
